import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../../shared/shared.module';
import { etablissementType } from '../../../../../shared/utils/data/etablissments-data';

@Component({
  selector: 'app-second-step-add-establishment',
  standalone: true,
  imports: [
    CommonModule,
    SharedModule
  ],
  templateUrl: './second-step-add-establishment.component.html',
  styleUrls: ['./second-step-add-establishment.component.scss']
})
export class SecondStepAddEstablishmentComponent {
  @Input() form!: FormGroup;
  @Output() onValidated = new EventEmitter<any>();

  nextStep(): void {
    if (this.form.valid) {
      this.onValidated.emit(this.form.value);
    }
  }

  onSiretInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const numeric = input.value.replace(/\D/g, '').slice(0, 14);
    input.value = numeric;
    this.form.get('numsiret')?.setValue(numeric);
  }

  onFinessInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const numeric = input.value.replace(/\D/g, '').slice(0, 9);
    input.value = numeric;
    this.form.get('numfiness')?.setValue(numeric);
  }

  checkBoxChange(value: string) {
    this.form.get('platformManagedBy')?.setValue(value);
  }

  get isFormDisabled(): boolean {
    return this.form.invalid;
  }

  protected readonly etablissementType = etablissementType;
}
